// The Speed priced and when it arrives, in the backend's words ("Standard ·
// usually arrives Tue 20 Oct", or "Check with our team"): the page never
// works a date out itself. Choosing among the Speeds is the portal's next
// step (d60), built on the same response.
export function ArrivalLine({ sentence }: { sentence: string }) {
  return <p className="text-sm text-muted-foreground">{sentence}</p>;
}
